import React, { useState } from 'react';
import AccordionItem from './AccordionItem';
import { useTranslation } from 'react-i18next';

function Accordion({ title, iconSrc, items, maxVisibleItems = 8, type }) {
  const { t } = useTranslation();
  const [visibleItems, setVisibleItems] = useState(maxVisibleItems);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleShowMore = () => {
    setVisibleItems(isExpanded ? maxVisibleItems : items.length);
    setIsExpanded(!isExpanded);
  };

  const hasValidItems = Array.isArray(items) && items.some(item =>
    Object.values(item || {}).some(value => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && value !== '';
    })
  );

  return (
    <div className="accordion-container">
      {/* タイトルとアイコン */}
      <div className="section-title">
        <span className="icon">
          <img src={iconSrc} alt={title} width="20" height="20" />
        </span>
        <span className="title-text">{title}</span>
      </div>

      {/* 履歴がない場合のメッセージ */}
      {!hasValidItems ? (
        <div className="maintenance-empty">{t('accordion.noHistory', { title })}</div>
      ) : (
        <>
          {/* 履歴アイテムの表示 */}
          {items.slice(0, visibleItems).map((item, index) => {
            const details = type === 'cleaning' ? [
              { label: t('accordion.cleaning.type'), value: item.type || 'N/A' },
              { label: t('accordion.cleaning.detergent'), value: item.detergent || 'N/A' },
              { label: t('accordion.cleaning.company'), value: item.company || 'N/A' }
            ] : [
              { label: t('accordion.repair.part'), value: item.part || 'N/A' },
              { label: t('accordion.repair.content'), value: item.content || 'N/A' },
              { label: t('accordion.repair.company'), value: item.company || 'N/A' }
            ];

            return <AccordionItem key={index} date={item.date} details={details} />;
          })}

          {/* もっと見る / 閉じるボタン（履歴が8件以上の場合のみ表示） */}
          {items.length > maxVisibleItems && (
            <div className="show-more-container">
              <button className="show-more-btn" onClick={handleToggleShowMore}>
                <span className="show-more-text">{isExpanded ? t('accordion.showLess') : t('accordion.showMore')}</span>
                <span className="icon-arrow">
                  <img
                    src={isExpanded ? '/images/icon/icon_arrow_up.svg' : '/images/icon/icon_arrow_down.svg'}
                    alt={isExpanded ? t('accordion.showLess') : t('accordion.showMore')}
                    width="15"
                    height="15"
                  />
                </span>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Accordion;
